import { Star } from "lucide-react";

/** Cinco estrelas arredondadas conforme `value` (0..5). */
export function Stars({ value }) {
  const rounded = Math.round(Math.max(0, Math.min(5, Number(value) || 0)));
  return (
    <div className="inline-flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          className={`w-3.5 h-3.5 ${
            n <= rounded ? "fill-amber-400 text-amber-400" : "text-zinc-300 dark:text-zinc-700"
          }`}
        />
      ))}
    </div>
  );
}
